import React from "react";
import { Link } from "react-router-dom";
import "../service.css";

export const HowToBook = () => {
  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>How to book</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">How to book</li>
          </ul>
        </div>
      </div>
      <div className="container" style={{ paddingTop: "90px" }}>
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1" style={{ textAlign: "center" }}>
          Book tickets your way
        </h1>

        {/*         <img
          src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2024-01/india_passenger_getting_out_farexbus.jpg"
          className="basic-page-header-image basic-page-paragraph-container"
          alt=""
          data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_0_5x/s3/2024-01/india_passenger_getting_out_farexbus.jpg 390w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page/s3/2024-01/india_passenger_getting_out_farexbus.jpg 780w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_1_5x/s3/2024-01/india_passenger_getting_out_farexbus.jpg 1170w"
          sizes="100vw"
        /> */}

        <div id="section-43694" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <p>
              There are many options to <strong>book your ride</strong>.
              Here, you can find an overview of all booking options. This
              step-by-step guide helps you find your way around and book your
              ticket <strong>online</strong>, via the<strong> App</strong>, in
              our <strong>Hireme Lounge</strong>, or through one of our
              third-party resellers.
            </p>
          </div>
        </div>

        <div id="section-43695" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h2>Booking on our website</h2>
          </div>
        </div>

        <div id="section-43696" style={{ clear: "both" }}>
          <div className="basic-page-paragraph-container" style={{ clear: "both" }}>
            <div className="farex-grid image-text-horizontal-left">
              {/*   <div className="farex-col-12 farex-col-6-md image-text-horizontal-image-wrapper-left">
                <figure>
                  <div className="image-with-copyright-info--container">
                    <img
                      src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2024-01/india_elderly_couple_in_bus.jpg"
                      className="image-text-horizontal-image"
                      alt=""
                      height="258px"
                      width="360px"
                      data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/image_text_horizontal/s3/2024-01/india_elderly_couple_in_bus.jpg 360w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/image_text_horizontal_2x/s3/2024-01/india_elderly_couple_in_bus.jpg 720w"
                      sizes="(min-width: 600px) 360px, 100vw"
                    />

                    <p className="image-with-copyright-info--text">© Hireme</p>
                  </div>
                </figure>
              </div> */}

              <div className="farex-col-12 farex-col-12-md">
                <div className="farex-text image-text-horizontal-text">
                  <h4>Step 1: Choose your trip with just 3 clicks</h4>
                  <ul>
                    <li>
                      Select the boarding point, dropping point, and date of
                      your outgoing and return trip.
                    </li>
                    <li>Choose the number of passengers.</li>
                    <li>
                      Click "Search" to find your trip with the best price.
                    </li>
                  </ul>
                  <p>
                    <span>
                      Once you've found your desired trip, you can reserve your
                      favourite seat(s) to add the trip to your cart. Your seats
                      are reserved in the cart for 10 minutes, so you'll have
                      enough time to proceed with your booking. If you do not
                      reserve a seat, one will be assigned to you.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="section-43697" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h4>Step 2: Make your payment for tickets</h4>
            <p>
              Select your preferred payment method from the displayed list.
              Insert the required information and click on the button to proceed
              with the payment.
            </p>
            <h4>Step 3: Instant Confirmation</h4>
            {/* <p>
              <span>
                After you&apos;ve booked your trip, we will send you a trip
                summary via SMS with:
              </span>
            </p>
            <ul>
              <li>Date and time of your departure and arrival.</li>
              <li>City of departure and point of arrival.</li>
              <li>Your seat number.</li>
              <li>
                <span>
                  The link to your ticket with all details about your trip and
                  the passengers booked.
                </span>
              </li>
            </ul>
            <p>
              <span>
                The linked booking confirmation serves as your ticket. Please
                show it to the bus driver/host digitally or in printed form.
              </span>
            </p> */}
          </div>
        </div>

        <div id="section-43698" style={{ clear: "both" }}>
          <div className="farex-text " style={{ overflowY: "auto" }}>
            <h2>Booking via the App</h2>
          </div>
        </div>

        <div id="section-43699" style={{ clear: "both" }}>
          <div className="basic-page-paragraph-container" style={{ clear: "both" }}>
            <div className="farex-grid image-text-horizontal-left">
              {/* <div className="farex-col-12 farex-col-6-md image-text-horizontal-image-wrapper-left">
                <figure>
                  <div className="image-with-copyright-info--container">
                    <img
                      src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2024-01/india_passenger_tablet_2.jpg"
                      className="image-text-horizontal-image"
                      alt=""
                      height="258px"
                      width="360px"
                      data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/image_text_horizontal/s3/2024-01/india_passenger_tablet_2.jpg 360w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/image_text_horizontal_2x/s3/2024-01/india_passenger_tablet_2.jpg 720w"
                      sizes="(min-width: 600px) 360px, 100vw"
                    />

                    <p className="image-with-copyright-info--text">@ Hireme</p>
                  </div>
                </figure>
              </div> */}

              <div className="farex-col-12 farex-col-12-md">
                <div className="farex-text image-text-horizontal-text">
                  <ul>
                    <li>
                      <strong>Step 1: </strong>Download the Hireme App from the
                      Google Play Store or the App Store
                    </li>
                    <li>
                      <strong>Step 2: </strong>Book your trip conveniently via
                      the App
                    </li>
                    <li>
                      <strong>Step 3: </strong>Pay for your trip by selecting
                      your preferred payment method
                    </li>
                  </ul>
                  <p>
                    You&apos;ll receive a booking confirmation including all
                    trip details via e-mail.
                  </p>
                  <p>
                    Find more information on the <Link to={"/"}>Hireme App</Link>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="section-43700" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h2>Book your trip at a Hireme Lounge</h2>
            <p>
              <span>
                Need to buy your ticket or get assistance for your trip? At our{" "}
              </span>
              l
              <span>
                ounge, you will find our staff ready to assist you with all your
                needs.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
